"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _formWrapper = _interopRequireDefault(require("../../formWrapper.js"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _CccisdWysiwyg = _interopRequireDefault(require("../helpers/CccisdWysiwyg.js"));
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _arrowUp = _interopRequireDefault(require("cccisd-icons/arrow-up"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down"));
var _plusCircle = _interopRequireDefault(require("cccisd-icons/plus-circle2"));
var _cross = _interopRequireDefault(require("cccisd-icons/cross"));
var _pencil = _interopRequireDefault(require("cccisd-icons/pencil5"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _generateNewId = require("../helpers/generateNewId.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = ['id', 'showFaq', 'showChat', 'contact.startsOpen', 'contact.showContactText', 'contact.contactHeader', 'contact.email', 'contact.phone', 'faq.headerText', 'faq.limit', 'faq.showMoreText', 'faq.showFewerText', 'faq.questions[].id', 'faq.questions[].question', 'faq.questions[].answer', 'liveChat.buttonText', 'liveChat.embedToken'];
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (!values.question) {
    errors.question = 'Question is required';
  }
  if (!values.answer) {
    errors.answer = 'Answer is required.';
  }
  return errors;
};
var HelpCenterForm = function HelpCenterForm(props) {
  var _props$fields = props.fields,
    showFaq = _props$fields.showFaq,
    showChat = _props$fields.showChat,
    contact = _props$fields.contact,
    faq = _props$fields.faq,
    liveChat = _props$fields.liveChat;
  var addQuestion = function addQuestion(values) {
    faq.questions.addField(_objectSpread({
      id: (0, _generateNewId.generateNumericId)({
        list: faq.questions
      })
    }, values));
  };
  var editQuestion = function editQuestion(values, index) {
    if (typeof values.question !== 'undefined') {
      faq.questions[index].question.onChange(values.question);
    }
    if (typeof values.answer !== 'undefined') {
      faq.questions[index].answer.onChange(values.answer);
    }
  };
  var getItemStyle = function getItemStyle(isDragging) {
    return {
      userSelect: 'none',
      background: isDragging ? '#f0f0f0' : ''
    };
  };
  var onDragEnd = function onDragEnd(result) {
    var startIndex = result.source.index;
    var endIndex = result.destination.index;
    if (startIndex <= endIndex) {
      for (var i = startIndex; i < endIndex; i++) {
        faq.questions.swapFields(i, i + 1);
      }
    } else {
      for (var _i = startIndex; _i > endIndex; _i--) {
        faq.questions.swapFields(_i, _i - 1);
      }
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h2", null, "Contact Information"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-3'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Email",
    field: contact.email
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-3'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Phone",
    field: contact.phone
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-6'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Contact Header Text",
    field: contact.contactHeader
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: contact.startsOpen.value,
    onChange: function onChange() {
      return contact.startsOpen.onChange(!contact.startsOpen.value);
    },
    label: "Contact information starts visible"
  }), contact.startsOpen.value || /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-6'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Text of link to show contact information",
    field: contact.showContactText
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formelement
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showChat.value,
    onChange: function onChange() {
      return showChat.onChange(!showChat.value);
    },
    label: "Live Chat enabled"
  }), showChat.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-6'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Live Chat launch button text",
    field: liveChat.buttonText
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-6'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Happy Fox Embed Token for the site",
    field: liveChat.embedToken
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }))), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("h2", null, "Frequently Asked Questions (FAQ)"), /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showFaq.value,
    onChange: function onChange() {
      return showFaq.onChange(!showFaq.value);
    },
    label: "Include FAQ"
  }), showFaq.value && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].faq
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-6'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "FAQ Header Text",
    field: faq.headerText
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].firstblock + ' col-xs-8'
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: faq.limit,
    label: "Number of questions to show initially"
  }, /*#__PURE__*/_react["default"].createElement("select", _extends({
    className: "form-control"
  }, (0, _cccisdReduxFormHelpers.domOnlyProps)(faq.limit)), /*#__PURE__*/_react["default"].createElement("option", {
    value: "0"
  }, "No limit"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "1"
  }, "1"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "2"
  }, "2"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "3"
  }, "3"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "4"
  }, "4"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "5"
  }, "5"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "6"
  }, "6"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "7"
  }, "7"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "8"
  }, "8"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "9"
  }, "9"), /*#__PURE__*/_react["default"].createElement("option", {
    value: "10"
  }, "10")))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }), faq.limit.value > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].indented
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Text of link to show more questions",
    field: faq.showMoreText
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Text of link to show fewer questions",
    field: faq.showFewerText
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "clearfix"
  }), /*#__PURE__*/_react["default"].createElement("h3", null, "Questions"), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Add question",
    trigger: /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].formelement
    }, /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-primary",
      type: "button"
    }, /*#__PURE__*/_react["default"].createElement(_plusCircle["default"], null), " Add question")),
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
        onSubmit: function onSubmit(values) {
          addQuestion(values);
          closeModal();
        },
        validate: validate,
        render: function render() {
          return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "question",
            component: _CccisdWysiwyg["default"],
            label: "Question"
          }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
            name: "answer",
            component: _CccisdWysiwyg["default"],
            label: "Answer"
          }), /*#__PURE__*/_react["default"].createElement("button", {
            className: "btn btn-primary",
            type: "submit"
          }, "Add Question"));
        }
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable",
    direction: "vertical"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({}, provided.droppableProps, {
      ref: provided.innerRef
    }), faq.questions.map(function (question, index) {
      return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
        draggableId: question.id.value.toString(),
        index: index,
        key: question.id.value
      }, function (dragProvided, dragSnapshot) {
        return /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].faqItem,
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps), /*#__PURE__*/_react["default"].createElement("div", _extends({
          className: _style["default"].dragHandle
        }, dragProvided.dragHandleProps, {
          style: getItemStyle(dragSnapshot.isDragging, dragProvided.draggableProps.style)
        }), /*#__PURE__*/_react["default"].createElement(_arrowUp["default"], null), /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faqPreview
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faqControls
        }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
          title: "Edit question",
          trigger: /*#__PURE__*/_react["default"].createElement("button", {
            type: "button",
            className: _style["default"].faqButton + ' btn btn-default btn-xs'
          }, /*#__PURE__*/_react["default"].createElement(_pencil["default"], null), " Edit"),
          render: function render(_ref2) {
            var closeModal = _ref2.closeModal;
            return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
              onSubmit: function onSubmit(values) {
                editQuestion(values, index);
                closeModal();
              },
              render: function render() {
                return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  name: "question",
                  component: _CccisdWysiwyg["default"],
                  label: "Question",
                  value: question.question.value
                }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
                  name: "answer",
                  component: _CccisdWysiwyg["default"],
                  label: "Answer",
                  value: question.answer.value
                }), /*#__PURE__*/_react["default"].createElement("button", {
                  className: "btn btn-primary",
                  type: "submit"
                }, "Edit Question"));
              }
            });
          }
        }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
          title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_cross["default"], null), " Delete"),
          className: _style["default"].faqButton + ' btn btn-danger btn-xs',
          isConfirm: true,
          confirmationMessage: "Are you sure you want to delete this question: \"".concat(question.question.value, "\""),
          onClick: function onClick() {
            return faq.questions.removeField(index);
          }
        })), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].faqQuestion
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].q
        }, "Q."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: question.question.value
        })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
          className: _style["default"].a
        }, "A."), /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: question.answer.value
        }))));
      });
    }));
  }))));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields
})(HelpCenterForm);